// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --filterBtnBoxShadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  --btnBoxShadow: rgba(96, 94, 94, 0.25) 1.45px 1.45px 2.1px;
  --btnHoverBoxShadow: rgba(52, 51, 51, 0.25) 1.45px 1.45px 2.1px 1px, rgba(96, 94, 94, 0.25) 0px 0.5px 0.5px;
  --dividerShadow: rgba(0, 0, 0, 0.24) 0px 1px 1.5px;
}

.base-icon-styles {
  fill: #426ba6;
  scale: 1;
  transition: scale 0.3s cubic-bezier(0.22, 1, 0.36, 1);
}
button:not(:disabled):hover .base-icon-styles {
  scale: 1.5;
}
button:disabled .base-icon-styles {
  opacity: 0.6;
}

.icon-hover:hover {
  scale: 1.5;
}

.icon-disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.icon-disabled:hover {
  scale: 1;
}

.not-selected {
  fill: transparent;
}
.not-selected:hover {
  scale: 1;
}

.icon-fill {
  fill: currentColor;
}

button:not(:disabled):hover .no-scale {
  scale: 1;
}

.icon-react-table {
  opacity: 0.6;
}

.icon-upload {
  fill: #829ec4;
}

.modal_close {
  opacity: 0.8;
}

.icon-warning {
  fill: #d3c71c;
}

.icon-error {
  fill: #b72025;
}

.icon-success {
  fill: #00dbbb;
}

.icon-logo {
  fill: #6d91c6;
}

.icon-ready {
  opacity: 0.6;
}
button:hover .icon-ready {
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/Components/App/vars.scss","webpack://./src/Components/Icon/Icon.scss"],"names":[],"mappings":"AA8CA;EACE,sDAAA;EACA,0DAAA;EACA,2GAAA;EACA,kDAAA;AC7CF;;AAHA;EACE,aDWU;ECVV,QAAA;EACA,qDAAA;AAMF;AALE;EACE,UAAA;AAOJ;AALE;EACE,YAAA;AAOJ;;AAJA;EACE,UAAA;AAOF;;AAJA;EACE,YAAA;EACA,mBAAA;AAOF;AANE;EACE,QAAA;AAQJ;;AAJA;EACE,iBAAA;AAOF;AANE;EACE,QAAA;AAQJ;;AAJA;EACE,kBAAA;AAOF;;AAHE;EACE,QAAA;AAMJ;;AAFA;EACE,YAAA;AAKF;;AAFA;EACE,aD9BS;ACmCX;;AAFA;EACE,YAAA;AAKF;;AAFA;EACE,aD9Ca;ACmDf;;AAFA;EACE,aDnDY;ACwDd;;AAFA;EACE,aDrDY;AC0Dd;;AAFA;EACE,aDjDS;ACsDX;;AAFA;EACE,YAAA;AAKF;AAJE;EACE,UAAA;AAMJ","sourcesContent":["$border-thin: 1px solid #426ca65e;\n\n//colors\n$tableBgColor: #fff;\n$placeholderColor: #a3b9d9;\n$borderColor: #a3b9d9;\n$borderColorLight: #dae1ec;\n$accentFilterColor: #ff8040;\n$accentColor: #b72025;\n$warningColor: #d3c71c;\n$succesColor: #00dbbb;\n$accentTableRowColor: #ecc0c1;\n$filtersBgColor: #d6dfea71; //#d6dfea\n$filterTitleColor: #d6dfea93;\n$textColor: #426ba6;\n$filtersBorderColor: #426ba6;\n$deletedTextColor: #b72025;\n$iconFill: #829ec4;\n$logoIcon: #6d91c6;\n$activeBtnColor: rgba(218, 225, 236, 1);\n\n//fonts\n$baseFontSize: 16px;\n\n//sizes\n$baseHeight: 720;\n$baseWidth: 1190;\n$borderRadius: 5px;\n\n$inputSelectBgColor: #ffffffeb;\n$inputSelectHoverBgColor: #d6dfea93;\n\n//shadows\n$filterBtnBoxShadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;\n$btnBoxShadow: rgba(96, 94, 94, 0.25) 1.45px 1.45px 2.1px;\n$reactTableShadow: rgba(67, 71, 85, 0.27) 0px 0px 0.25em, rgba(90, 125, 188, 0.05) 0px 0.25em 1em;\n$btnHoverBoxShadow: rgba(52, 51, 51, 0.25) 1.45px 1.45px 2.1px 1px, rgba(96, 94, 94, 0.25) 0px 0.5px 0.5px;\n$dividerShadow: rgba(0, 0, 0, 0.24) 0px 1px 1.5px;\n$commonShadow: rgba(67, 71, 85, 0.27) 0px 0px 0.25em, rgba(90, 125, 188, 0.05) 0px 0.25em 1em;\n$commonShadowHover: rgba(67, 71, 85, 0.27) 1px 1px 0.25em, rgba(90, 125, 188, 0.05) 1px 0.3em 1em;\n\n$transition: ease;\n$transitionFunc: cubic-bezier(0.25, 1, 0.5, 1);\n$iconHoverTransition: cubic-bezier(0.22, 1, 0.36, 1);\n$commonTransition: 0.3s $transitionFunc;\n\n:root {\n  --filterBtnBoxShadow: #{$filterBtnBoxShadow};\n  --btnBoxShadow: #{$btnBoxShadow};\n  --btnHoverBoxShadow: #{$btnHoverBoxShadow};\n  --dividerShadow: #{$dividerShadow};\n}\n\n$main-font: \"Roboto\", sans-serif;\n\n$font-weights: (\n  \"Light\": 300,\n  \"Regular\": 400,\n  \"Medium\": 500,\n  \"Bold\": 700,\n);\n","@use \"../App/vars.scss\" as v;\n\n.base-icon-styles {\n  fill: v.$textColor;\n  scale: 1;\n  transition: scale 0.3s v.$iconHoverTransition;\n  button:not(:disabled):hover & {\n    scale: 1.5;\n  }\n  button:disabled & {\n    opacity: 0.6;\n  }\n}\n.icon-hover:hover {\n  scale: 1.5;\n}\n\n.icon-disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  &:hover {\n    scale: 1;\n  }\n}\n\n.not-selected {\n  fill: transparent;\n  &:hover {\n    scale: 1;\n  }\n}\n\n.icon-fill {\n  fill: currentColor;\n}\n\n.no-scale {\n  button:not(:disabled):hover & {\n    scale: 1;\n  }\n}\n\n.icon-react-table {\n  opacity: 0.6;\n}\n\n.icon-upload {\n  fill: v.$iconFill;\n}\n\n.modal_close {\n  opacity: 0.8;\n}\n\n.icon-warning {\n  fill: v.$warningColor;\n}\n\n.icon-error {\n  fill: v.$accentColor;\n}\n\n.icon-success {\n  fill: v.$succesColor;\n}\n\n.icon-logo {\n  fill: v.$logoIcon;\n}\n\n.icon-ready {\n  opacity: 0.6;\n  button:hover & {\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
